var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        {
          attrs: {
            label: _vm.label,
            "label-for": _vm.id,
            description: _vm.description
          }
        },
        [
          _c("b-form-textarea", {
            staticStyle: { overflow: "hidden" },
            attrs: {
              maxlength: _vm.maxlength,
              rows: _vm.rows,
              "max-rows": _vm.maxRows,
              id: _vm.id,
              placeholder: _vm.placeholder,
              readonly: _vm.readOnly,
              "no-resize": _vm.noResize
            },
            model: {
              value: _vm.localValue,
              callback: function($$v) {
                _vm.localValue = $$v
              },
              expression: "localValue"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a962cc9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a962cc9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/forms/BaseTextarea.vue
// module id = 1601
// module chunks = 120